import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/2u0gcj71_la_rotonde_logo_cachet_R%204.png"
              alt="La Rotonde"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 mb-4 text-lg">
              Restaurant – Divonne-les-Bains
            </p>
            <p className="text-gray-400 leading-relaxed">
              Un lieu chargé d'histoire. Une table contemporaine.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('concept')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Le Restaurant
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('histoire')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Histoire
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  La Carte
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('equipe')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  L'Équipe
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('reservation')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Réserver
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{contactInfo.address}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} className="flex-shrink-0" />
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} className="flex-shrink-0" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} La Rotonde – Tous droits réservés
            </p>
            <div className="text-gray-400 text-sm text-center md:text-right">
              <p>{contactInfo.hours.weekdays.days}</p>
              <p className="text-xs">{contactInfo.hours.weekdays.lunch}</p>
              <p className="text-xs">{contactInfo.hours.weekdays.dinner}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;